import React, {  useEffect } from 'react';
import Hometopimage from '../../assets/images/mpeztop.jpg';
import haavc from '../../assets/images/haavc.jpeg';
import solar from '../../assets/images/solar.jpeg';
import plumbing from '../../assets/images/plumbing.png';
import datacabling from '../../assets/images/datacabling.webp';
import electrical from '../../assets/images/electrical.jpeg';
import fireproduction from '../../assets/images/fireproduction.jpeg';
import { MdElectricBolt } from "react-icons/md";
import civilapproach from '../../assets/images/whypatner.jpg';
import electricaldataimages from '../../assets/images/electricaldataimages.jpg';
import plumbingdataimage from '../../assets/images/plumbingdataimage.jpg';
import haavcdataimages from '../../assets/images/haavcdataimages.jpeg';
import Faq from '../../components/Faq/Faq';

//aos animation
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import Metatag from '../../components/Metatag/Metatag';

const Mpez = () => {
    useEffect(() => {
        // Scroll to the top when the page loads
        window.scrollTo(0, 0);
      }, []);
    
    useEffect(() => {
        AOS.init({
          once:true,
        });
      }, []);
    const accordionItems = [
        {
          title: 'ill the company assist with upgrading and modernizing substations?',
          content: (
            <p>
              This is the first item's accordion body.It is shown by default, until the collapse plugin adds
              the appropriate classes that we use to style each element.
              This is the first item's accordion body.It is shown by default, until the collapse plugin adds
              the appropriate classes that we use to style each element.
            </p>
          ),
        },
        {
          title: 'Advantages do testing and diagnostics for substations offer?',
          content: (
            <p>
              This is the second item's accordion body. It is hidden by default, until the collapse plugin
              adds the appropriate classes.
              This is the first item's accordion body.It is shown by default, until the collapse plugin adds
              the appropriate classes that we use to style each element.
              This is the first item's accordion body.It is shown by default, until the collapse plugin adds
              the appropriate classes that we use to style each element.
            </p>
          ),
        },
        {
          title: 'Can you offer specialized substation solutions?',
          content: (
            <p>
              This is the third item's accordion body. It is hidden by default, until the collapse plugin
              adds the appropriate classes.
              This is the first item's accordion body.It is shown by default, until the collapse plugin adds
              the appropriate classes that we use to style each element.     This is the first item's accordion body.It is shown by default, until the collapse plugin adds
              the appropriate classes that we use to style each element.
            </p>
          ),
        },
        {
            title: 'Advantages do testing and diagnostics for substations offer?',
            content: (
              <p>
                This is the second item's accordion body. It is hidden by default, until the collapse plugin
                adds the appropriate classes.
                This is the first item's accordion body.It is shown by default, until the collapse plugin adds
                the appropriate classes that we use to style each element.
                This is the first item's accordion body.It is shown by default, until the collapse plugin adds
                the appropriate classes that we use to style each element.
              </p>
            ),
          },
      ];
    const mpezDatas = [
        {
            heading: "HAAVC",
            subheading: "Fueling Advancement: Pioneering Substation Construction for the Future.",
            text: "Air quality and comfort depend mainly on HVAC (heating, ventilation, and air conditioning) systems. Our specialty at Megavolt offers advanced HVAC systems that fit your needs. Effective installation, upkeep, and repair services are provided by our staff, ensuring peak performance and comfortable conditions all year round.",
            img: haavcdataimages,

        },
        {
            heading: "ELECTRICALS",
            subheading: "Creating Exclusivity: Villas for Outstanding Living.",
            text: "Today's world runs on invisible electrical systems. Megavolt is a trail setter in avant solutions that empower various sectors and areas. Innovative and dependable electrification that improves safety and efficiency in multiple settings is our key priority, from the initial setup to the continuous maintenance.",
            img: electricaldataimages,
        }, {
            heading: "PLUMBING",
            subheading: "Foundations for Success: Distinctive warehouse Services",
            text: "At Megavolt Contracting LLC, we take great satisfaction in providing plumbing services at the forefront of accuracy and quality. Among the most prominent companies in the marketplace, we have plumbing knowledge for various projects. Our years of experience allow us to apply our best practices to every plumbing project, from exhaustive installations to effective repairs.",
            img: plumbingdataimage,
        },

    ]
    const mpezIamages = [
        {
            img: haavc,
            text: "HVAC",
        },
        {
            img: solar,
            text: "SOLARSYSTEM",
        },
        {
            img: plumbing,
            text: "PLUMBING",
        },
        {
            img: datacabling,
            text: "DATACABLING",
        },
        {
            img: fireproduction,
            text: "FIREPRODUCTION",
        },
        {
            img: electrical,
            text: "ELECTRICALS",
        },
    ]
    return (
        <div>
            <Metatag title = "MEPZ | Boost Your Export and Manufacturing Business" description=" Discover the advantages of MEPZ for businesses.
Maximize export opportunities, enjoy tax benefits, and access world-class infrastructure. Learn how MEPZ can accelerate your growth." link="mpez"/>
            <div className=' '>
                <div className=' overflow-hidden relative bg-cover bg-no-repeat bg-center w-full h-full' style={{ backgroundImage: `url(${Hometopimage})`, backgroundRepeat: 'no-repeat' }}>
                    <div className=' absolute inset-0 bg-black  opacity-45'></div>
                    <div className='  relative  p-3 sm:p-12 pb-8 sm:pb-20' data-aos="fade-left" data-aos-duration="2500" data-aos-delay="200">

                        <h1 className=' mt-2 sm:mt-6 text-[#feb231] font-bold text-2xl sm:text-4xl'><span className=' text-white text-3xl sm:text-6xl'>The UAE's </span> Leading MEP</h1>
                        <h1 className=' mt-1 sm:mt-2 text-[#feb231] font-bold text-2xl sm:text-5xl'>Contractor <span className=' text-white text-3xl sm:text-6xl'>   Company</span> </h1>
                        <p className=' mt-2 sm:mt-4 text-xl text-white'>Where Precision Meets Power. Discover innovative solutions</p>
                        <p className='  text-xl text-white'>in Mechanical, Electrical, and Plumbing services tailored for</p>
                        <p className='  text-xl text-white'>your success</p>
                        <Link to='/contactus'>
                       
                        <button className=' bg-[#feb231] rounded-xl px-3 p-2 mt-8 text-[#000000] font-semibold hover:shadow-[1px_4px_1px_0px_rgba(0,0,1)]' >
                            Stay Connect
                        </button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className=' bg-[#feb231]'>
                <div className=' p-3 lg:p-1 sm:pt-7  container overflow-hidden'>
                <h1 className="sm:mb-4 mb-2 text-xl pt-1 sm:pt-6 font-bold uppercase text-center md:text-4xl">
                        Meeting Your Diverse Needs
                    </h1>
                <p className="text-sm md:text-base text-[white]  container text-justify sm:text-center leading-6">We value creativity and craftsmanship, collaborating with top talents to ensure exceptional outcomes for your projects.</p>
                    <div className='grid grid-flow-row grid-cols-1 md:grid-cols-2  overflow-hidden lg:grid-cols-3 gap-5 mt-6 sm:mt-12 pb-6'>
                        {mpezIamages.map((item, index) => (
                            <div key={index}
                             data-aos="zoom-in" data-aos-duration="1000" data-aos-delay={index * 200} data-aos-offset="100"
                             className='overflow-hidden rounded-xl'>
                                <img
                                    src={item.img}
                                    className='w-full h-48 sm:h-56 lg:h-64 object-cover rounded-xl hover:scale-[1.05] ease-linear transition-transform duration-200'
                                    alt='Substation'
                                />
                                <p className='pt-4 text-center font-semibold text-black'>{item.text}</p>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
            <div className=''>
            <div className=' sm:mt-6 container p-3 lg:p-0'>
                <h1 className="mb-4 text-2xl font-bold  text-center md:text-4xl"> Why Partner with Us?</h1>
                <div className=' grid  grid-cols-12 gap-4 mt-2 sm:mt-9  lg:p-0'>
                <div className=' col-span-12 sm:col-span-5 '>
                        <img src={civilapproach} className=' w-full h-full object-cover' alt="image" />
                    </div>
                    <div className=' col-span-12 sm:col-span-7 sm:p-4'>
                        <h1 className=' pt-1 sm:pt-2 text-orange text-2xl font-semibold'> Our Value to Your Vision</h1>
                        <p className="text-sm md:text-base text-[#7a7a7a]  pt-3 font-semibold  text-justify leading-6">Entering into a partnership with us in the dynamic realm of civil services ensures not just collaboration, but a transformative journey in knowledge, creativity, and an unwavering commitment to quality. Backed by extensive experience and a deep understanding of the complexities involved in villa development, our expert team is equipped to provide a range of tailored solutions that align perfectly with your specific needs.</p>
                        <div className=' flex items-center pt-4 group w-max '>
                            <MdElectricBolt className='text-[#feb231] group-hover:text-black ' /> <p className=' pl-2 group-hover:text-[#feb231] text-black '>Tailored Solutions</p>
                        </div>

                        <div className=' flex items-center pt-4 group w-max '>
                            <MdElectricBolt className='text-[#feb231] group-hover:text-black ' /> <p className=' pl-2 group-hover:text-[#feb231] text-black '>Expert Guidance</p>
                        </div>
                        <div className=' flex items-center pt-4 group w-max '>
                            <MdElectricBolt className='text-[#feb231] group-hover:text-black ' /> <p className=' pl-2 group-hover:text-[#feb231] text-black '>Sustainable Practices</p>
                        </div>
                    </div>
                  
                </div>
            </div>  

                <div className=' container mt-4'>
                <h1 className="sm:mb-4 mb-2 text-xl pt-1 sm:pt-6 font-bold uppercase text-center md:text-4xl">Our Expertise</h1>
                    <p className="text-sm md:text-base text-[#7a7a7a]  p-3 container text-justify sm:text-center leading-6">At Megavolt Contracting LLC, we proudly offer a diverse array of specialized interior design contractors services, each carefully formed to fulfill the distinct requirements of our clients. Discover our proficiency in creating an outstanding environment.</p>
                    <div className='mt-0 sm:mt-16  container p-3 lg:p-0'>
                        {mpezDatas.map((item, index) => (
                            <div key={index}>
                                <div
                                    className={`flex flex-col sm:flex-row gap-2 sm:gap-6 mt-4 pb-8 sm:mt-8 ${index % 2 === 0 ? '' : 'sm:flex-row-reverse'
                                        }`}
                                >
                                    <div className='flex-1'>
                                        <div className=' h-full '>
                                            <img
                                                src={item.img}
                                                className='w-full h-64 sm:h-80 lg:h-[320px] object-cover rounded-md'
                                                alt={item.heading}
                                            />
                                        </div>
                                    </div>
                                    <div className='flex-1 flex flex-col justify-center '>
                                    <p className=" mb-1 sm:mb-4 text-2xl sm:pt-6 pt-1 font-bold  text-center md:text-4xl"> {item.heading}</p>
                                <p className='pt-2 sm:pt-3 text-[#f7b12d] text-center font-semibold text-[19px] sm:text-xl'>{item.subheading}</p>
                                <p className="text-sm md:text-base text-[#7a7a7a]  pt-3 font-semibold  sm:text-justify    leading-6">{item.text}</p>
                          
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Faq items={accordionItems}/>
        </div>

    )
}

export default Mpez